import { GLOBAL, redirect } from 'saddlebag-browser';

import type { SearchParams } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';
import type { NavigateFunction } from 'react-router-dom';

export const getRedirectUrl = (url: string): string => {
  const $window = GLOBAL.getWindow();
  const redirectUrl = `${$window.location.protocol}//${$window.location.host}${url}`;
  return redirectUrl;
};

export const redirectWithCheck = (
  navigate: NavigateFunction,
  url: string,
  searchParams: SearchParams,
  check?: boolean,
) => {
  if (check) {
    redirect(getRedirectUrl(url));
  } else {
    navigate(url, { state: { searchParams } });
  }
};

export const openNewTabWithCheck = (
  navigate: NavigateFunction,
  url: string,
  searchParams: SearchParams,
  check?: boolean,
  onOpenFail?: () => void,
) => {
  if (check) {
    const $window = GLOBAL.getWindow();
    const windowProxy: unknown | null = $window.open(getRedirectUrl(url), '_blank');

    /**
     * NOTE: https://developer.mozilla.org/en-US/docs/Web/API/Window/open
     * Returns null when it was blocked by a browser popup blocker
     * */
    if (!windowProxy) onOpenFail?.();
  } else {
    navigate(url, { state: { searchParams } });
  }
};
